<template>
    <div>
        <kgr-loading v-if="loading" />
        <div v-else>
            <kgr-empty-data
                v-if="logs.length === 0"
                :value="$t('dataTable.noData')"
            />
            <table
                v-else
                class="kgr-table kgr-table--striped kgr-table--block table-groups"
            >
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Datum') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Uhrzeit') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Meldung') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(log, index) in logs"
                        :key="index"
                        class="kgr-table__row  kgr-table__row--top"
                    >
                        <td class="kgr-table__cell">
                            {{ log.date }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ log.time }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ log.message }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData.vue';
import Loading from '../common/Loading.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-empty-data': EmptyData,
        'kgr-loading': Loading,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            logs: [],
        };
    },
    created() {
        this.load();
    },
    methods: {
        async load() {
            this.loading = true;
            const { data } = await axios.get(`/federations/${this.federationId}/personio/logs`);
            this.logs = data.data;
            this.loading = false;
        },
    },
};
</script>
